export const VALUE_TYPE_ANY = 'any' as const;
export const VALUE_TYPE_FIXED = 'fixed' as const;
export const VALUE_TYPE_SUGGESTIONS = 'suggestions' as const;
export const VALUE_TYPE_CHOOSE = 'choose' as const;
export const VALUE_TYPE_EMPTY = 'empty' as const;

export const VALUE_TYPE = {
  SUGGESTIONS: VALUE_TYPE_SUGGESTIONS,
  CHOOSE: VALUE_TYPE_CHOOSE,
  EMPTY: VALUE_TYPE_EMPTY,
  FIXED: VALUE_TYPE_FIXED,
  ANY: VALUE_TYPE_ANY,
};
